import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { AppLocalizationService } from '../../../services/AppLocalizationService';

/**
 * Returns a Date formatted ***IN RD LOCALE***
 */
@Pipe({ name: 'rdLocalizedDate' })
export class RdLocalizedDatePipe implements PipeTransform {
  /**
   * Constructor
   * @param datePipe DatePipe
   */
  constructor(private datePipe: DatePipe, private appLocalization: AppLocalizationService) { }

  /**
   * Returns a Date formatted ***IN RD LOCALE***
   * @param input Date input
   */
  transform(input: any): string {
    const dictionaryConfig = this.appLocalization.getReportDesignerDictionaryConfig();
    let format = dictionaryConfig.dateFormat;
    if (!format) {
      format = 'dd/MM/yyyy';
    }

    let date: Date = null;

    if (typeof (input) === 'string') {
      date = moment(input).toDate();
    }
    else if (input instanceof Date) {
      date = input;
    }

    if (date) {
      return this.datePipe.transform(date, format);
    }

    return '';
  }
}
